<template>
  <svg class="stroke-current w-8 h-8 mr-1 md:mr-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.86 40.38"><g fill="none"><rect x=".5" y="15.81" width="40.86" height="24.07" rx="2.32"/><path d="M16.49 9.12h18.33a2 2 0 0 1 2 2v4.71H14.48v-4.69a2 2 0 0 1 2-2zm7.92 16.15h13.4m-13.4 4.86h13.4M24.41 35h13.4M7.42 0v13.61m16.99 6.88H28m6.24 0h3.57m-8.49 0h3.58"/><circle cx="12.59" cy="27.84" r="9.07"/><path d="M12.59 18.78v18.13m-4.7-17.04v15.85m9.5-15.85v15.85m4.32-7.93H3.58m17.04-4.7H4.77m15.85 9.51H4.77m-.52-18.99h6.65v2.2H4.25z"/></g></svg>
</template>

<script>
export default {

};
</script>

<style>

</style>
